import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Logout from '../components/auth/Logout';

const ExpireSession = props => {
  return (
    <Modal
      show={true}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title>Your session is expired.</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          Please logout and log back in to use Ink.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Logout />
      </Modal.Footer>
    </Modal>
  );
}

export default ExpireSession;
